import { createSelector } from 'reselect'
import { LabFeatureFlags } from 'constants/lab'
import { isFeatureTogglePayload } from 'lib/lab/dynamicPayload'

const DEFAULT_FEATURES: App.FunnelFeatureToggles = {
  walledGarden: true,
  roomUpgrade: true,
  luxPlus: true,
  flights: true,
  experiences: true,
  cfmr: true,
  travelProtection: true,
  carHire: true,
}

export const getFunnelFeatures = createSelector(
  (state: App.State) => state.system.features.labFlags[LabFeatureFlags.enableFunnelOptimiser],
  (funnelFlag: App.LabFeatureFlagResult): App.FunnelFeatureToggles => {
    if (!funnelFlag?.enabled) {
      return DEFAULT_FEATURES
    }

    const funnelToggles = funnelFlag.value

    if (!isFeatureTogglePayload(funnelToggles)) {
      return DEFAULT_FEATURES
    }

    const toggles: App.FunnelFeatureToggles = {
      walledGarden: funnelToggles.toggles?.walledGarden ?? DEFAULT_FEATURES.walledGarden,
      roomUpgrade: funnelToggles.toggles?.roomUpgrade ?? DEFAULT_FEATURES.roomUpgrade,
      luxPlus: funnelToggles.toggles?.luxPlus ?? DEFAULT_FEATURES.luxPlus,
      flights: funnelToggles.toggles?.flights ?? DEFAULT_FEATURES.flights,
      experiences: funnelToggles.toggles?.experiences ?? DEFAULT_FEATURES.experiences,
      cfmr: funnelToggles.toggles?.cfmr ?? DEFAULT_FEATURES.cfmr,
      travelProtection: funnelToggles.toggles?.travelProtection ?? DEFAULT_FEATURES.travelProtection,
      carHire: funnelToggles.toggles?.carHire ?? DEFAULT_FEATURES.carHire,
    }

    return toggles
  },
)
